module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"product":"Produtos mais acessados","application":"Aplicações mais acessadas","publication":"Publicações mais acessadas"},"en":{"product":"Most viewed products","application":"Most viewed applications","publication":"Most viewed publications"},"es":{"product":"Productos más visitados","application":"Aplicaciones más visitadas","publication":"Publicaciones más visitadas"}}')
  delete Component.options._Ctor
}
